(function($, FUNCTIONS){

	// 郵便番号から住所入力
	const zipSearch = () => {
		let inputCodeVal = $('#input_zipcode').val().replace(/-/g, '');
		let $pref = $('#input_pref');
		let $city = $('#input_city');
		let $address = $('#input_address');

		const getZipCloudAPI = (_param) => {
			return $.getJSON(
				'//zipcloud.ibsnet.co.jp/api/search?callback=?',
				{ zipcode: _param },
			);
		};

		if (inputCodeVal.length === 7) {
			getZipCloudAPI(inputCodeVal).then((data) => {
				if (data.status === 200) {
					if (!data.results) {
						alert('郵便番号に該当する住所が見つかりません');
					} else {
						$pref.val(data.results[0].address1);
						$city.val(data.results[0].address2);
						$address.val(data.results[0].address3);
					}
				}
			});
		}
	};

	$('.js-zipSearch').on('click', () => { zipSearch(); });


	// 同意チェックされたら確認ボタンを有効化する
	$('#form_agree').on('change', (e) => {
		if ($(e.currentTarget).prop('checked')) {
			$('#form_submit').prop('disabled', false);
		} else {
			$('#form_submit').prop('disabled', true);
		}
	});

})(window.jQuery, window.FUNCTIONS);
